import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  InputGroupText,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./AdminPembekalanOnePage.module.css";

const API_URL =
  "https://graduation.rlagency.id/api/api-admin/get-pembekalan-register-nim.php";
const UPDATE_API =
  "https://graduation.rlagency.id/api/api-admin/update-jam-kehadiran.php";

const AdminPembekalanOnePage = () => {
  const [nim, setNim] = useState("");
  const [modalData, setModalData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Use useEffect to force rerender when modalData changes
  useEffect(() => {
    if (modalData) {
      setShowModal(true); // Ensure modal shows when new data is set
    }
  }, [modalData]);

  const handleSearch = async () => {
    // Reset modal data before fetching new data
    setModalData(null);
    setShowModal(false);

    try {
      const response = await axios.get(`${API_URL}?nim=${nim}`);
      if (response.data && response.data.data.length > 0) {
        setModalData(response.data.data[0]);
      } else {
        toast.error("Data tidak ditemukan.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Terjadi kesalahan saat mencari data.");
    }
  };

  const handleUpdate = async () => {
    try {
      const response = await axios.post(UPDATE_API, {
        nim,
        waktu_kehadiran: new Date().toLocaleString(),
      });

      if (response.data.status === "success") {
        toast.success("Data berhasil diperbarui!");
        setShowModal(false);
      } else {
        toast.error("Gagal memperbarui data.");
      }
    } catch (error) {
      console.error("Error updating data:", error);
      toast.error("Terjadi kesalahan saat memperbarui data.");
    }
  };

  return (
    <div className={styles.bodyContainer}>
    <div className={styles.adminContainer}>
      <h2 className={styles.h2This}>Pembekalan Wisuda</h2>

      <div className={styles.inputGroup}>
        <InputGroupText className={styles.inputGroupLabel}>NIM</InputGroupText>
        <Input
          value={nim}
          onChange={(e) => setNim(e.target.value)}
          className={styles.inputField}
        />
      </div>

      <Button className={styles.searchBtn} onClick={handleSearch}>
        Cari
      </Button>

      <Modal isOpen={showModal} toggle={() => setShowModal(false)} size="md" centered>
        <ModalHeader toggle={() => setShowModal(false)} className={styles.modalHeader}>
          Data Pembekalan Wisuda
        </ModalHeader>
        
        <ModalBody>
            {modalData ? (
                <div className={styles.modalBodyContent}>
                <div className={styles.card}>

                    <h3 className={styles.nama}>{modalData.nama}</h3>

                    <div className={styles.infoRow}>
                    <span className={styles.label}>🎓 Fakultas</span>
                    <span className={styles.info}>{modalData.fakultas}</span>
                    </div>

                    <div className={styles.infoRow}>
                    <span className={styles.label}>📚 Jurusan</span>
                    <span className={styles.info}>{modalData.jurusan}</span>
                    </div>
                </div>
                </div>
            ) : (
                <p className={styles.notFound}>Data tidak ditemukan.</p>
            )}
        </ModalBody>


        <ModalFooter>
          <Button className={styles.closeBtn} onClick={() => setShowModal(false)}>
            Tutup
          </Button>
          <Button className={styles.updateBtn} onClick={handleUpdate}>
            Update
          </Button>
        </ModalFooter>
      </Modal>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
    </div>
  );
};

export default AdminPembekalanOnePage;
